import * as React from 'react';
import useTranslation from '../../hooks/useTranslation';

import('./CallToActionStyles.scss');


interface CallToActionPresentationProps {
    phaseId: number
    countdown: number
    activeChannelId: number
}

class CallToActionPresentation extends React.Component<CallToActionPresentationProps, any> {
    requestAnimationFrameId: number = null;

    constructor(props: CallToActionPresentationProps) {
        super(props);
        const { phaseId } = this.props;
        
        this.state = {
            countdown: this.props.countdown,
            betstop:isBetstop(phaseId),
        };
    }
    
    componentDidMount() {
        if(!this.state.betstop) {
            this.updateCountdown(this.state.countdown, this.state.betstop);
        }
    }

    componentDidUpdate(prevProps: CallToActionPresentationProps) {
        const { phaseId, countdown } = this.props;
        const betstop = isBetstop(phaseId);
        
        if(prevProps.activeChannelId !== this.props.activeChannelId) {
            window.cancelAnimationFrame(this.requestAnimationFrameId);
            this.requestAnimationFrameId = null;
        }
        
        if(!betstop && this.requestAnimationFrameId === null && countdown > 0) {
            this.updateCountdown(countdown, betstop);
        }else if (prevProps.phaseId !== phaseId && betstop) {
            window.cancelAnimationFrame(this.requestAnimationFrameId);
            this.requestAnimationFrameId = null;
            this.setState(() => ({
                countdown: 0,
            }));
        }
    }

    componentWillUnmount() {
        window.cancelAnimationFrame(this.requestAnimationFrameId);
        this.requestAnimationFrameId = null;
    }

    updateCountdown(countdown: number,betstop:boolean) {
        let self = this;
        let start = 0;
        let startCountdown = countdown;
        function callback(timestamp: number) {
            if(start === 0) {
                start = timestamp;
            }
        
            countdown = startCountdown - Math.round((timestamp - start) / 1000);
            self.setState(() => ({
                countdown: countdown,
            }));

            if( !betstop && countdown > 0) {
                self.requestAnimationFrameId = window.requestAnimationFrame(callback);
            }
        }
      
        this.requestAnimationFrameId = window.requestAnimationFrame(callback);
    }

    render() {
        const { props } = this;
        return (
            <div>
                <div className="callToActionContainer">
                    <ShowCtaTextDiv {...props} countdown={this.state.countdown} />
                    <ShowCtaCountdownDiv currentPhaseOfActiveChannel={props.phaseId} countdown={this.state.countdown ? this.state.countdown : 0} />
                </div>
            </div>
        );
    }
};

function isBetstop(phaseId: number) {
    return [4, 5, 8].includes(phaseId);
}

const ShowCtaTextDiv = (props: { countdown: number, phaseId: number }) => {
    const placeYourBetsText = useTranslation('Countdown_placeYourBets');
    const liveText = useTranslation('Countdown_live');

    return (
        <div className="textContent textContentCurvedLeft">
            {props.countdown >= 0 && !isBetstop(props.phaseId) 
                ? placeYourBetsText 
                : liveText}
        </div>
    );
};

const toggleBlinking = (phaseId: number, countdownValue: number) => {
    // if phaseId is 3 (pre point) or 6 (post point) it is possible to blink
    if ( phaseId !== 3 && phaseId !== 6 ) {
        return ' ';
    }
    
    if ( countdownValue < 6 && countdownValue >= 0 ) {
        return ' fade-bg ';
    } else {
        return ' ';
    }
};

const ShowCtaCountdownDiv = (props: { currentPhaseOfActiveChannel: number, countdown: number }) => { 
    let minutes = Math.floor(props.countdown / 60);
    let seconds = minutes <= 0 ? props.countdown : props.countdown % (minutes * 60);

    if (  isBetstop(props.currentPhaseOfActiveChannel) && props.countdown == 0  ) {
        return (
            <div className="countdownContent">
                <span className="ctaLock"></span>
            </div>  
        );
    } else {
        return (
            <div className="countdownContent">
                <span className={toggleBlinking(props.currentPhaseOfActiveChannel, props.countdown)}>
                    {minutes}:{String(seconds).padStart(2, '0')}
                </span>
            </div>        
        );
    }
};

export default CallToActionPresentation;
